module.exports = __webpack_public_path__ + "img/menu_EXETR.5ff404fc.svg";